
import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';

@Component({
    selector: 'org-metrics',
    template: require('./org.metrics.html')
})
export class OrgMetricsComponent implements OnInit {

    @Input() usageData: any;
    @Input() maxMembers: string = '';
    @Input() diskQuota: string = '';
    @Input() isProjectAdmin: boolean = false;

    protected disk: any = {};
    protected users: any = {};

    private resourceBarOptions = {
        useColorGraduation: true,
        useLargeSize: true
    };

    constructor(private stateService: StateService) { }
    
    ngOnInit() {
        var diskQuota = parseInt(this.diskQuota) || 0,
            maxMembers = parseInt(this.maxMembers) || 0,
            disk = parseInt(_.get(this.usageData, 'disk', 0)),
            users = parseInt(_.get(this.usageData, 'users', 0));

        //Validate that disk is a number. This applies to the case where disk usage
        //information is not yet available and thus the value is not an int
        disk = Number.isInteger(disk) ? disk : 0;

        this.disk = {
            amountComplete: disk,
            amountTotal: diskQuota,
            percentComplete: diskQuota > 0 ? 
                Math.round( (disk / diskQuota) * 100) : 0
        };

        this.users = {
            amountComplete: users,
            amountTotal: maxMembers,
            percentComplete: maxMembers > 0 ? 
                Math.round( (users / maxMembers) * 100 ) : 
                0
        };
    };
}
